import { createMixin, addEventListener } from '.';

const useEventListener = (controller) => {
  const listenerRemovals = [];

  controller.addEventListener = (target, name, handler, options) => {
    const removal = addEventListener(target, name, handler, options);
    listenerRemovals.push(removal);
    return () => {
      const index = listenerRemovals.indexOf(removal);

      ~index && listenerRemovals.splice(index, 1);

      removal();
    };
  };

  const disconnect = () => {
    for (const removal of listenerRemovals) {
      removal();
    }
    listenerRemovals.length = 0;
  };

  return disconnect;
};

/**
 * Allows to apply event listeners to objects with automatic cleanup.
 * Meaning that you don't need to manually do anything in disconnect() method.
 * @example Usage
 *   class MyController extends Controller {
 *     connect() {
 *       useEventListener(this);
 *       this.addEventListener(document, 'submit', (e) => console.log(e))
 *     }
 *   }
 *
 * @param {Object} controller
 * @return {void}
 */
export default createMixin(useEventListener);
